import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/** Alias legado → Contas unificadas (aba receber). */
const ContasAReceber: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate('/financeiro/contas?tab=receber', { replace: true });
  }, [navigate]);
  return null;
};

export default ContasAReceber;
